import Application from '@ember/application';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import config from 'uplisting-frontend/config/environment';
import 'ember-cached-decorator-polyfill';
import '@glint/environment-ember-loose';
import { startSentry } from 'uplisting-frontend/sentry';
import 'uplisting-frontend/font-awesome';
import '@warp-drive/ember/install';

if (config.IS_DEV) {
  import('uplisting-frontend/inspector-support');
}

startSentry();

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver;
}

loadInitializers(App, config.modulePrefix);
